<template>
  <section
    class="go-contacto relative bg-cover bg-center"
    :style="{ backgroundImage: `url(${backgroundImage})` }"
  >
    <div class="hero-overlay"></div>
    <div class="relative flex flex-col items-center justify-center h-full text-center px-6">
      <span class="eyebrow eyebrow-light mb-4">¿Hablamos?</span>
      <h2 class="hero-title text-4xl md:text-6xl font-bold text-white">Contacto</h2>
      <span class="divider-line divider-line-light mt-6"></span>
      <p class="mt-6 text-base md:text-lg max-w-2xl mx-auto text-white/95 font-light italic">
        Me encantaría escucharte. Ponte en contacto conmigo en Jeshu Beauty para hacer preguntas o solicitar más información sobre los servicios de belleza.
      </p>
      <router-link to="/contact" class="btn-on-purple mt-9">
        Enviar Mensaje
        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
        </svg>
      </router-link>
    </div>
  </section>
</template>

<script>
import backgroundImage from '@/assets/florfooter1.jpg';
export default {
  name: 'GoContacto',
  data() {
    return {
      backgroundImage,
    };
  },
};
</script>

<style scoped>
.go-contacto {
  height: 55vh;
  min-height: 380px;
  background-size: cover;
  background-position: center;
}

@media (min-width: 768px) {
  .go-contacto {
    height: 42vh;
    min-height: 360px;
  }
}
</style>
